var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addVolunteeringHoursFunctionDef, approveVolunteeringHoursFunctionDef, approveVolunteersFunctionDef, deleteVolunteeringHoursFunctionDef, denyVolunteerFunctionDef, denyVolunteeringHoursFunctionDef, getPastApprovedParticipationsFunctionDef, requestShiftParticipationFunctionDef, withdrawSelfFunctionDef, withdrawVolunteersFunctionDef, } from '../../../../backend/features/shift/shared';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { MissionContext } from '../../../../ui/providers';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { useContext } from 'react';
export const useShiftParticipantActions = () => {
    const { t } = useMissionsTranslation();
    const requestShiftParticipationPlatformFn = useTypedPlatformFunction(requestShiftParticipationFunctionDef);
    const denyVolunteerPlatformFn = useTypedPlatformFunction(denyVolunteerFunctionDef);
    const approveVolunteersPlatformFn = useTypedPlatformFunction(approveVolunteersFunctionDef);
    const withdrawVolunteersPlatformFn = useTypedPlatformFunction(withdrawVolunteersFunctionDef);
    const withdrawSelfPlatformFn = useTypedPlatformFunction(withdrawSelfFunctionDef);
    const addVolunteeringHoursPlatformFn = useTypedPlatformFunction(addVolunteeringHoursFunctionDef);
    const approveVolunteeringHoursPlatformFn = useTypedPlatformFunction(approveVolunteeringHoursFunctionDef);
    const deleteVolunteeringHoursPlatformFn = useTypedPlatformFunction(deleteVolunteeringHoursFunctionDef);
    const denyVolunteeringHoursPlatformFn = useTypedPlatformFunction(denyVolunteeringHoursFunctionDef);
    const getPastApprovedParticipationsPlatformFn = useTypedPlatformFunction(getPastApprovedParticipationsFunctionDef);
    const onRequestShiftParticipation = (params) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield requestShiftParticipationPlatformFn(params);
        return result;
    });
    const { onAccountNotificationSend } = useContext(MissionContext);
    const handleSubmit = (requestParams) => {
        return onRequestShiftParticipation === null || onRequestShiftParticipation === void 0 ? void 0 : onRequestShiftParticipation(requestParams).catch(handleErrorDialog);
    };
    const handleDeny = (denyParams) => {
        return denyVolunteerPlatformFn(denyParams)
            .then(() => {
            showAlertSnackbar({
                message: t('shifts.pendingRequest.denyShift.denied'),
                autoHideDuration: 2000,
                type: 'success',
            });
        })
            .catch(handleErrorDialog);
    };
    const handleApprove = (approveParams) => {
        return approveVolunteersPlatformFn({
            shiftId: approveParams.shiftId,
            shiftParticipations: approveParams.shiftParticipations,
        })
            .then(() => {
            showAlertSnackbar({
                message: t('shifts.pendingRequest.approveShift.approvedInfoSnackbar'),
                autoHideDuration: 2000,
                type: 'success',
            });
        })
            .catch(handleErrorDialog);
    };
    const handleWithdraw = (withdrawParams) => {
        return withdrawVolunteersPlatformFn({
            shiftId: withdrawParams.shiftId,
            shiftParticipations: withdrawParams.shiftParticipations,
        })
            .then(() => {
            showAlertSnackbar({
                message: t('shifts.pendingRequest.withdrawShift.withdrawInfoSnackbar'),
                autoHideDuration: 2000,
                type: 'success',
            });
        })
            .catch(handleErrorDialog);
    };
    const handleSelfWithdrawal = (params) => __awaiter(void 0, void 0, void 0, function* () {
        yield withdrawSelfPlatformFn(params)
            .then(() => {
            showAlertSnackbar({
                message: t('missions.missionDetails.shiftWithdrawn'),
                autoHideDuration: 2000,
                type: 'success',
            });
        })
            .catch(handleErrorDialog);
    });
    const handleAddHours = (addHoursParams) => {
        return addVolunteeringHoursPlatformFn({
            shiftId: addHoursParams.shiftId,
            participationId: addHoursParams.participationId,
            shiftStartTime: addHoursParams.shiftStartTime,
            shiftStopTime: addHoursParams.shiftStopTime,
            missionOrganizationSharing: addHoursParams.missionOrganizationSharing,
        })
            .then(() => {
            showAlertSnackbar({
                message: t('shifts.adminTimeTracking.approvedInfoSnackBar'),
                autoHideDuration: 2000,
                type: 'success',
            });
        })
            .catch(handleErrorDialog);
    };
    const handleApproveHours = (approveHoursParams) => {
        return approveVolunteeringHoursPlatformFn({
            participationIds: approveHoursParams.participationIds,
        })
            .then(() => {
            showAlertSnackbar({
                message: t('shifts.adminTimeTracking.approvedInfoSnackBar'),
                autoHideDuration: 2000,
                type: 'success',
            });
        })
            .catch(handleErrorDialog);
    };
    const handleDeleteHours = (deleteHoursParams) => {
        return deleteVolunteeringHoursPlatformFn({
            participationIds: deleteHoursParams.participationIds,
        })
            .then(() => {
            showAlertSnackbar({
                message: t('shifts.adminTimeTracking.deletedInfoSnackBar'),
                autoHideDuration: 2000,
                type: 'success',
            });
        })
            .catch(handleErrorDialog);
    };
    const handleDenyHours = (denyHoursParams) => {
        return denyVolunteeringHoursPlatformFn(denyHoursParams).catch(handleErrorDialog);
    };
    const fetchPastApprovedParticipations = (params) => {
        return getPastApprovedParticipationsPlatformFn(params).catch(handleErrorSnackbar);
    };
    const sendMessageToVolunteers = onAccountNotificationSend
        ? (accountIds) => {
            onAccountNotificationSend(accountIds);
        }
        : undefined;
    return {
        handleApprove,
        handleAddHours,
        handleDeny,
        handleApproveHours,
        handleDeleteHours,
        handleDenyHours,
        handleSubmit,
        handleWithdraw,
        handleSelfWithdrawal,
        sendMessageToVolunteers,
        fetchPastApprovedParticipations,
    };
};
